
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Index from "./pages/Index";
import MetalFab from "./pages/MetalFab";
import NotFound from "./pages/NotFound";
import DirectoryScannerTest from "./DirectoryScannerTest";
import SimplePasswordGate from "./components/SimplePasswordGate";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <SimplePasswordGate>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/metal-fab" element={<MetalFab />} />
            <Route path="/directory-scanner-test" element={<DirectoryScannerTest />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </SimplePasswordGate>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
